module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jt4Ex"))).then(() => module.bundle.root('d0iPb'));